import { createPinia } from 'pinia'
export const piniaStore = createPinia()
